import { render } from "./LabPaid1View.vue?vue&type=template&id=160e3694"
import script from "./LabPaid1View.vue?vue&type=script&lang=js"
export * from "./LabPaid1View.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__